import {PatternShift} from '@domain/calendar/pattern/pattern-shift';
import {SchedulePreview} from '@domain/calendar/schedule/schedule-preview';
import {UuidUtils} from '@vdw/angular-component-library';
import {DateTime, Duration} from 'luxon';
import {ShiftStubFactory} from '../shift/shift-stub-factory';

export class SchedulePreviewStubFactory {
  public static getRandomSchedulePreview(): SchedulePreview[] {
    const today = DateTime.now().startOf('day');
    const shift = ShiftStubFactory.getRandomShift();
    const schedulePreview: SchedulePreview[] = [];
    for (let i = -3; i <= 30; i++) {
      schedulePreview.push(
        new SchedulePreview(today.plus({days: i}), true, [
          new PatternShift(UuidUtils.generateV4Uuid(), null, shift, Duration.fromObject({hours: 7}), Duration.fromObject({hours: 13}), []),
          new PatternShift(UuidUtils.generateV4Uuid(), null, shift, Duration.fromObject({hours: 13}), Duration.fromObject({hours: 19}), []),
          new PatternShift(UuidUtils.generateV4Uuid(), null, shift, Duration.fromObject({hours: 22}), Duration.fromObject({days: 1, hours: 4}), [])
        ])
      );
    }
    return schedulePreview;
  }
}
